export enum OnboardingFlow {
  SIGN_IN = "sign-in",
  SIGN_UP = "sign-up",
}

export enum OnboardingStep {
  AUTHORIZATION, // initial screen
  ACCOUNT_NOT_FOUND, // account not found
  CREATE_ACCOUNT, // create account screen
  ACCOUNT_CREATION_IN_PROGRESS, // loader for account creation
  CLAIMING_REWARDS_IN_PROGRESS, // loader for claiming rewards
  ACCOUNT_CREATED, // account successfully created
}
